/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-numero-police': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M15.37 0H7a.4.4 0 00-.17.09l-4.5 4.5a.31.31 0 00-.09.17v12.86a.38.38 0 00.38.38h12.75a.38.38 0 00.38-.38V.37a.38.38 0 00-.38-.37zM6.75 1.28v2.84a.38.38 0 01-.37.38H3.53zm6.37 14.47H4.88a.38.38 0 110-.75h8.24a.38.38 0 110 .75zm0-2.25H4.88a.38.38 0 110-.75h8.24a.38.38 0 110 .75zm0-2.25H4.88a.38.38 0 110-.75h8.24a.38.38 0 110 .75zm0-2.25H4.88a.38.38 0 110-.75h8.24a.38.38 0 110 .75zm0-2.25H4.88a.38.38 0 110-.75h8.24a.38.38 0 110 .75zm0-2.25H9.38a.38.38 0 110-.75h3.74a.38.38 0 110 .75z"/>'
  }
})
